import DownloadAppAndroidIcon from '@/assets/all-icons/download-app-android-icon';
import DownloadAppAndroidText from '@/assets/all-icons/download-app-android-text';
import DownloadAppAppleIcon from '@/assets/all-icons/download-app-apple-icon';
import DownloadAppAppleText from '@/assets/all-icons/download-app-apple-text';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';

import './styles/DownloadAppPopup.css';

const APP_STORE_LINK = process.env.REACT_APP_DOWNLOAD_APPLE_URL || "https://apps.apple.com/es/app/suarte/id6736384682?l=en-GB";
const PLAY_STORE_LINK = process.env.REACT_APP_DOWNLOAD_GOOGLE_URL || "https://play.google.com/store/apps/details?id=app.suarte.online&hl=es";

export default function DownloadAppPopup({ open=false, onClose }) {
  function handleClose() {
    if (typeof onClose === 'function') {
      onClose(true);
    }
  }

  return (
    <GenericPopup
      open={open}
      onBackgroundClick={handleClose}
      className="download-app-popup__card"
      backgroundClassName="download-app-popup__overlay"
      animation
      opacity
    >
      <button
        type="button"
        className="download-app-popup__close"
        aria-label="Close download prompt"
        onClick={handleClose}
      >
        &times;
      </button>
      <div className="download-app-popup__content">
        <p className="download-app-popup__eyebrow">GET THE APP</p>
        <h3 className="download-app-popup__title">
          <span className="download-app-popup__title-line">
            For the best Suarte experience.
          </span>
          <span className="download-app-popup__title-line">
            <span className="download-app-popup__title-accent">Faster</span>
            <span className="download-app-popup__title-dot">.</span>
            <span className="download-app-popup__title-accent"> Smoother</span>
            <span className="download-app-popup__title-dot">.</span>
          </span>
        </h3>
        <p className="download-app-popup__description">
          Join the social marketplace for fine art. Likes, ratings, artlists, one-tap checkout and more.
        </p>
        <div className="download-app-popup__actions">
          <a
            className="download-app-popup__store-link"
            href={APP_STORE_LINK}
            target="_blank"
            rel="noreferrer"
          >
            <span className="download-app-popup__store-link-content">
              <DownloadAppAppleIcon className="download-app-popup__store-icon" />
              <DownloadAppAppleText className="download-app-popup__store-text" />
            </span>
          </a>
          <a
            className="download-app-popup__store-link"
            href={PLAY_STORE_LINK}
            target="_blank"
            rel="noreferrer"
          >
            <span className="download-app-popup__store-link-content">
              <DownloadAppAndroidIcon className="download-app-popup__store-icon" />
              <DownloadAppAndroidText className="download-app-popup__store-text" />
            </span>
          </a>
        </div>
      </div>
    </GenericPopup>
  );
}
